import React, { useState } from "react";
import { DateRangePicker } from "rsuite";
import MainHeading from "../../components/comman/MainHeading";
import PlusIcon from "../../components/Icons/PlusIcon";
import { Nav, NavItem, NavLink, TabContent, TabPane, Fade, Spinner } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import OfficeTaskManagement from "./OfficeTaskManagement";
import MeetingManagement from "./MeetingManagement";
import { updateFiltersStates } from "../../store/actions/UserActions";
import SearchSiteSelect from "../../components/comman/SiteSearchSelect";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import { callApi } from "../../ApiHelper/ApiHelper";

function TaskManagement() {
    const dispatch = useDispatch();
    const userDetails = useSelector((state) => state.root.userDetails);
    const filterDetails = useSelector((state) => state.root.filtersStates);
    const [activeTab, setActiveTab] = useState("Tasks");
    const [localDateRange, setLocalDateRange] = useState([]);
    const [pageStates, setPageState] = useState({
        siteList: [],
        isLoadingSite: false,
        siteId: filterDetails?.siteId || null,
        initialized: false,
    });

    React.useEffect(() => {
        if (!pageStates.initialized) {
            GetSiteList();
            setPageState(prev => ({ ...prev, initialized: true }));
        }
    }, []);

    const GetSiteList = (search = null) => {
        return new Promise((resolve) => {
            let API =
                userDetails?.type === 2
                    ? `${apiUrl.get_site}?pageSize=100${search ? `&search=${search}` : ""}`
                    : `${apiUrl.get_user_site}?pageSize=100${search ? `&search=${search}` : ""}`;

            setPageState((prev) => ({ ...prev, isLoadingSite: true }));

            callApi(API, { method: "GET" })
                .then((response) => {
                    setPageState((prev) => ({ ...prev, isLoadingSite: false }));
                    if (!response?.status) return resolve([]);
                    const formatted = response.data?.site?.map((item) => ({
                        value: item?.site?.id || item.id,
                        label: item?.site?.name || item.name,
                    }));
                    setPageState((prev) => ({
                        ...prev,
                        siteList: formatted,
                    }));
                    resolve(formatted);
                })
                .catch(() => {
                    setPageState((prev) => ({ ...prev, isLoadingSite: false }));
                    resolve([]);
                });
        });
    };

    const handleYearChange = (selectedYear) => {
        setLocalDateRange([]);
        dispatch(
            updateFiltersStates({
                year: selectedYear,
            })
        );
    };

    const dateChangeHandler = (Dates) => {
        let formattedDate = null;
        if (Dates && Dates.length === 2) {
            const startDate = new Date(
                Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
            )
                .toISOString()
                .slice(0, 10);
            const endDate = new Date(
                Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
            )
                .toISOString()
                .slice(0, 10);
            formattedDate = [startDate, endDate];
        }
        if (formattedDate !== null) {
            setLocalDateRange(formattedDate);
        } else {
            setLocalDateRange([]);
        }
    };

    return (
        <>
            <MainHeading
                title="Office Task Management"
                handleYearChange={handleYearChange}
            >
                <div>
                    <DateRangePicker
                        size="sm"
                        format="dd/MM/yyyy"
                        placeholder="From - To"
                        placement="auto"
                        value={
                            localDateRange?.length === 2
                                ? [new Date(localDateRange[0]), new Date(localDateRange[1])]
                                : []
                        }
                        onChange={(value) => dateChangeHandler(value)}
                    />
                </div>
            </MainHeading>
            <p className="text-muted" style={{ marginBottom: "0.2rem", fontSize: "12px" }}>
                Manage and track tasks assigned to you and your team.
            </p>
            <div className="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-3">
                <Nav tabs className="nav nav-tabs border-0 mb-0">
                    <> <NavItem className="nav-item">
                        <NavLink
                            className={
                                activeTab === 'Tasks'
                                    ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-1 border-start-1 active"
                                    : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-1 border-start-1"
                            }
                            style={{ cursor: "pointer", minWidth: "200px", textAlign: "center", fontWeight: "bold" }}
                            onClick={() => {
                                setActiveTab('Tasks')
                            }}
                        >
                            Tasks
                        </NavLink>
                    </NavItem>
                        <NavItem className="nav-item">
                            <NavLink
                                className={
                                    activeTab === 'Meetings'
                                        ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                                        : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                                }
                                style={{ cursor: "pointer", minWidth: "200px", textAlign: "center", fontWeight: "bold" }}
                                onClick={() => {
                                    setActiveTab('Meetings')
                                }}
                            >
                                Meetings
                            </NavLink>
                        </NavItem>
                    </>
                </Nav>
                <div>
                    <SearchSiteSelect
                        style={{ minWidth: "35rem", paddingLeft: "30px" }}
                        value={pageStates?.siteList?.find((item) => item?.value === filterDetails?.siteId)?.value || null}
                        options={pageStates?.siteList}
                        onSelect={(value) => {
                            dispatch(updateFiltersStates({ siteId: value?.value || "" }));
                        }}
                        onSearch={(input) => {
                            if (!input.trim()) {
                                GetSiteList();
                                return;
                            }
                            GetSiteList(input);
                        }}
                        isLoading={pageStates?.isLoadingSite}
                        placeholder={"Select Site"}
                        showClearButton={true}
                    />
                </div>
            </div>

            <TabContent activeTab={activeTab}>
                <TabPane tabId={'Tasks'}>
                    <Fade in={activeTab === 'Tasks'} timeout={200}>
                        {activeTab === 'Tasks' && <OfficeTaskManagement localDateFilter={localDateRange} />}
                    </Fade>
                </TabPane>

                <TabPane tabId={'Meetings'}>
                    <Fade in={activeTab === 'Meetings'} timeout={200}>
                        {activeTab === 'Meetings' && <MeetingManagement localDateFilter={localDateRange} />}
                    </Fade>
                </TabPane>
            </TabContent>

        </>
    );
}

export default TaskManagement;
